import { InitialConstraints } from 'app/common/ui/data-grid';

import { TEntityGridColumn, TEntityGridConstraints } from '../../core';

type EntityGridFilterStates = TEntityGridConstraints['filter'];
type DataGridFilterModels = NonNullable<InitialConstraints['filter']>;

type EntityGridSortStates = TEntityGridConstraints['sorting'];
type DataGridSortModels = NonNullable<InitialConstraints['sort']>;

type EntityGridPaginationStates = TEntityGridConstraints['pageInfo'];
type DataGridPaginationModels = NonNullable<InitialConstraints['pagination']>;

type PrepareInitialConstraintsParams = {
  constraints: TEntityGridConstraints;
  columns: TEntityGridColumn[];
};
export function prepareEnityGridConstraints({
  constraints,
  columns,
}: PrepareInitialConstraintsParams): InitialConstraints {
  const filterModel: DataGridFilterModels = prepareFilterModel({
    initialState: constraints.filter,
    columns,
  });

  const sortModel: DataGridSortModels = prepareSortModel(constraints.sorting);

  const paginationModel: DataGridPaginationModels = preparePaginationModel(
    constraints.pageInfo,
  );

  return {
    sort: sortModel,
    filter: filterModel,
    pagination: paginationModel,
  };
}

type PrepareFilterModelParams = {
  initialState: EntityGridFilterStates;
  columns: TEntityGridColumn[];
};
const prepareFilterModel = ({
  initialState,
  columns,
}: PrepareFilterModelParams): DataGridFilterModels => {
  const initialFilterStates = initialState ?? {};
  const foundFiterCols = [];

  for (const col of columns) {
    const filterName = col.filter?.filterName;
    const filterModelFactory = col.filter?.modelFactory;

    if (!filterName || !filterModelFactory) continue;

    if (filterName in initialFilterStates) {
      const filterInitialValue = initialFilterStates[filterName];
      const filterModel = filterModelFactory({
        filterName,
        // @ts-expect-error ...
        value: filterInitialValue,
      });

      foundFiterCols.push([col.field, filterModel]);
    }
  }
  const dataGridFilters = Object.fromEntries(foundFiterCols);

  return dataGridFilters;
};

type EntityGridSortDirections =
  NonNullable<EntityGridSortStates>[number]['direction'];
type DataGridSortDirections = NonNullable<DataGridSortModels>[number]['sort'];

const sortDirections: Record<EntityGridSortDirections, DataGridSortDirections> =
  {
    ascend: 'asc',
    descend: 'desc',
  };

function prepareSortModel(sortState: EntityGridSortStates): DataGridSortModels {
  if (!sortState) return [];

  const result = sortState.map((sort) => ({
    colId: sort.name,
    sort: sortDirections[sort.direction],
  }));

  return result;
}

function preparePaginationModel(
  pagination: EntityGridPaginationStates,
): DataGridPaginationModels {
  if (!pagination) return {};

  const result: DataGridPaginationModels = {
    page: pagination.page,
    pageSize: pagination.size,
  };

  return result;
}
